// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1YIsv","rightAdornment":"Header_rightAdornment__82HmJ"};